import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { GtmStatsDataTrackableInterface } from '../data/trackable.interface';
import { GtmStatsAdapterVariables } from './variables';
import { GtmStatsDataEventUserInterface } from '../data/event-user.interface';

export class GtmStatsAdapterEventUser implements StatsAdapterInterface {
  /**
   *
   * @param eventUser
   * @param context
   */
  constructor(
    protected eventUser: GtmStatsDataEventUserInterface | GtmStatsDataEventUserInterface[],
    protected context: StatsContextInterface
  ) {}

  /**
   * @inheritDoc
   */
  public getData(): GtmStatsDataTrackableInterface[] {
    const eventUser = Array.isArray(this.eventUser) ? this.eventUser : [this.eventUser];

    // User events first then update GTM variables
    return [...eventUser, new GtmStatsAdapterVariables(this.context).getData()];
  }
}
